import React from "react";
import styled from "styled-components";
import { portalColors } from "./BusinessPortalComponents";

const BaseLabel = styled.div`
    font-family: ${p => p.family || "Manrope, Helvetica, sans-serif"};
    font-weight: ${ p => p.weight || "normal" };
    font-size: ${ p => p.size || "1em" };
    color: ${ p => p.color || portalColors.text };
    text-align: ${ p => p.align || "start" };
    padding: ${ p => p.padding || "0" };
    margin: ${ p => p.margin || "0" };
    width: ${ p => p.width };
    height: ${ p => p.height };
    flex-grow: ${ p => p.flexGrow };
    max-width: ${ p => p.maxWidth };
    line-height: ${ p => p.lineHeight || "1.35" };
    box-sizing: border-box;
`;

/**
 * Base text label <div>, configurable with text size, weight and color, plus margin, padding, size, etc.
 * @return {JSX.Element}
 */
export function TextLabel(props) {
    const { children, ...styleProps } = props;
    return (
        <BaseLabel {...styleProps}>
            {children}
        </BaseLabel>
    );
}

/**
 * Text label configured for use as a page heading
 * @return {JSX.Element}
 */
export function PageHeadingLabel(props) {
    const { children, ...styleProps } = props;
    return (
        <BaseLabel
            weight="800"
            size="2.5em"
            color="var(--calendar-text, #171A22)"
            margin="0 0 0.5rem"
            maxWidth="43.125rem"
            lineHeight="1.15"
            {...styleProps}
        >
            { children }
        </BaseLabel>
    );
}

/**
 * Text label configured for use as an explainer paragraph
 * @return {JSX.Element}
 */
export function ExplainParagraphLabel(props) {
    const { children, ...styleProps } = props;

    return (
        <BaseLabel weight="400" size="14px" color="var(--calendar-text-muted, #808080)" margin="0.25em 0 0.5em" {...styleProps} >
            { children }
        </BaseLabel>
    );
}

/**
 * Text label configured for use as an explainer paragraph
 * @return {JSX.Element}
 */
export function CardHeadingLabel(props) {
    const { children, ...styleProps } = props;
    return (
        <BaseLabel
            weight="800"
            size="1.25em"
            color="var(--calendar-text, #171A22)"
            margin={props.margin || "0 0 0.5em"}
            {...styleProps}
        >
            { children }
        </BaseLabel>
    );
}
